export default __webpack_public_path__ + "static/media/Fnllogo.ef60ea41.png";